import React from 'react';
import { Page } from '../Page';
export function DividerLookingAhead() {
  return <Page hideFooter variant="dark" data-id="element-216">
      <div className="flex flex-col h-full justify-center items-center text-center" data-id="element-217">
        <p className="text-[10px] font-bold text-lightteal uppercase tracking-[0.25em] mb-4" data-id="element-218">
          Part Six
        </p>
        <h1 className="text-5xl font-serif text-white leading-tight mb-6" data-id="element-219">
          Looking Ahead
        </h1>
        <div className="w-16 h-0.5 bg-tealslate" data-id="element-220" />
      </div>
    </Page>;
}